<template>
  <div id="app">
    <div class="solp-start" v-if="!tweets.length">
      <h1>wiretap</h1>
      <div class="solp-start__caption">An exploration of digital conversation<br>inspired by <a href="http://www.digiart21.org/art/the-listening-post">Listening Post</a></div>
      <button v-on:click="start" class="solp-start__button">Start</button>
      <div class="solp-start__caption">Works best with your sound on</div>
      <div class="solp-start__caption solp-start__caption--small">Built by <a href="https://matteason.co.uk">Matt Eason</a> - Music by <a href="https://www.bensound.com/">Bensound</a></div>
    </div>
    <div class="solp-clouds" v-if="tweets.length"></div>
    <div class="solp-grid" v-if="tweets.length">
      <div class="solp-grid__column" :class="{ 'solp-grid__column--mobile' : isMobile}" v-for="(column, i) in tweetColumns" :key="i">
      <MatrixDisplay v-for="tweet in column" :msg="tweet.text" :key="tweet.id" :on="tweet.on"/>
      </div>
    </div>
  </div>
</template>

<script>
import MatrixDisplay from './components/MatrixDisplay.vue'

export default {
  name: 'App',
  components: {
    MatrixDisplay
  },
  data() {
    return {
      tweets: [],
      music: null,
      sayInterval: null,
      topics: ['i love', 'i hate', 'i think', 'i feel', 'i wish'],
      voice: null,
      isMobile: false
    }
  },
  computed: {
    numberOfTweets() {
      return (this.isMobile) ? 27 : 81;
    },
    tweetColumns() {
      if(this.isMobile) {
        return [
          this.tweets.slice(0, 9),
          this.tweets.slice(9, 18),
          this.tweets.slice(18, 27),
        ]
      } else {
        return [
          this.tweets.slice(0, 9),
          this.tweets.slice(9, 18),
          this.tweets.slice(18, 27),
          this.tweets.slice(27, 36),
          this.tweets.slice(36, 45),
          this.tweets.slice(45, 54),
          this.tweets.slice(54, 63),
          this.tweets.slice(63, 72),
          this.tweets.slice(72, 81),
        ]
      }
    }
  },
  methods: {
    start() {
      this.music = new Audio('./music/bensound-relaxing.mp3');
      this.music.loop = true;
      this.music.play();
      this.fetchRandomTopicTweets();
    },
    fetchRandomTopicTweets() {
      let topic;
      const urlParams = new URLSearchParams(window.location.search);
      const query = urlParams.get('q');
      if(query) {
        topic = decodeURI(query);
      } else {
        topic = this.topics[Math.floor(Math.random() * this.topics.length)];
      }
      console.log(`Topic selected: ${topic}`);
      let dummyTweets = [];
      for(let i = 0; i<this.numberOfTweets; i++) {
        dummyTweets.push({ id: i, on: false, hasBeenSpoken: false, text: '' });
      }
      dummyTweets[(this.numberOfTweets-1)/2] = { id: 'dummy', on: true, hasBeenSpoken: false, text: topic, readText: topic };
      this.tweets = dummyTweets;
      this.sayTweet(this.tweets[(this.numberOfTweets-1)/2]);
      setTimeout(() => {
        this.fetchTweets(topic);
      }, 2000);
    },
    fetchTweets(topic) {
      fetch(`https://public.api.bsky.app/xrpc/app.bsky.feed.searchPosts?q=%22${topic}%22%20-http%20-"bsky.social"%20-cock%20-dick%20-pussy%20-cunt%20-cum&lang=en&limit=${this.numberOfTweets}`, {
      })
        .then(response => response.json())
        .then(data => {
          this.tweets = data.posts.map(s => { return {
            id: s.cid,
            on: false,
            hasBeenSpoken: false,
            text: s.record.text.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '').replace(/[^0-9a-z ,'.?!’/]/gi, '').replace(' amp ','&'),
            readText: s.record.text.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '').replace(/[^0-9a-z ,'.?!’/#@]/gi, '').replace(' amp ','&').replace('#', ' hashtag').replace('@', 'at ')
          }});
          this.startPerformance();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    startPerformance() {
      this.sayNextTweet();
      setTimeout(this.turnOnRandomTweet, 10000*Math.random()+3000);
    },
    sayTweet(tweet) {
      console.log(`Saying ${tweet.readText}`);
      speechSynthesis.cancel();
      const utterance = new SpeechSynthesisUtterance(tweet.readText);
      utterance.voice = this.voice;
      speechSynthesis.speak(utterance);
      tweet.hasBeenSpoken = true;
      tweet.on = true;
    },
    sayNextTweet() {
      const eligibleTweets = this.tweets.filter(t => !t.hasBeenSpoken);

      if(eligibleTweets.length) {
        const tweet = eligibleTweets[Math.floor(Math.random() * eligibleTweets.length)];
        this.sayTweet(tweet);

        this.sayInterval = setInterval(() => {
          if (!speechSynthesis.speaking) {
            clearInterval(this.sayInterval);
            this.sayNextTweet();
          }
        }, 1000);
      }
    },
    turnOnRandomTweet() {
      const eligibleTweets = this.tweets.filter(t => !t.on);

      if(eligibleTweets.length) {
        eligibleTweets[Math.floor(Math.random() * eligibleTweets.length)].on = true;
        setTimeout(this.turnOnRandomTweet, Math.random()*2000+1000);
      } else {
        this.turnOffTweets();
      }
    },
    turnOffTweets() {
      console.log('No more tweets to turn on, turning them off');
      clearInterval(this.sayInterval);
      this.turnOffRandomTweet();
    },
    turnOffRandomTweet() {
      const eligibleTweets = this.tweets.filter(t => t.on);

      if(eligibleTweets.length) {
        eligibleTweets[Math.floor(Math.random() * eligibleTweets.length)].on = false;
        setTimeout(this.turnOffRandomTweet, Math.random()*500);
      } else {
        setTimeout(this.fetchRandomTopicTweets, 5000);
      }
    },
  },
  mounted() {
    this.isMobile = window.innerWidth < 1000;
    // wait on voices to be loaded before fetching list
    window.speechSynthesis.onvoiceschanged = () => {
      this.voice = speechSynthesis.getVoices().filter(function(voice) { return voice.name.includes("Zira") })[0];
    };
  }
}
</script>

<style lang="scss">
  @font-face {
    font-family: 'LED Dot-Matrix';
    src: url('./assets/font/LEDDotMatrixRegular.woff2') format('woff2'),
    url('./assets/font/LEDDotMatrixRegular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'DotSpot';
    src: url('./assets/font/DotSpot-Regular.woff2') format('woff2'),
    url('./assets/font/DotSpot-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  html {
    height: 100%;
  }

  body {
    font-family: "DotSpot", 'Courier New', 'Courier', monospace;
    background: radial-gradient(#001124, #012);
    padding: 0;
    margin: 0;
    overflow: hidden;
    user-select: none;

    * {
      box-sizing: border-box;
    }
  }

  #app {
    width: 100dvw;
    height: 100dvh;
    overflow: hidden;
    position: relative;
  }

  .solp-start {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 24px;
    line-height: 25px;
    text-align: center;

    h1 {
      font-weight: normal;
    }

    &__button {
      display: block;
      width: 200px;
      background: transparent;
      border: 2px solid white;
      color: white;
      border-radius: 25px;
      height: 50px;
      font-size: 40px;
      font-family: "Dotspot";
      cursor: pointer;
      margin: 20px auto;
    }

    &__caption {
      font-family: "LED Dot-Matrix";
      font-size: 15px;
      letter-spacing: 1px;

      &--small {
        font-size: 10px;
        letter-spacing: 2px;
      }
    }

    a:link,
    a:hover,
    a:active,
    a:visited {
      color: white;
    }
  }

  .solp-grid {
    display: flex;
    flex-direction: row;
    width: 100dvw;
    height: 100dvh;
    overflow: hidden;
    animation-iteration-count: infinite;
    animation-name: grid-effects;
    animation-duration: 180s;
    animation-direction: alternate;
    animation: none;
    perspective: 100vw;

    $text-color: #2ed4ba;
    @mixin displayshadow($boxOffset) {
      box-shadow:  $boxOffset 0 0 black, 0 -1px 0 rgb(20, 20, 30), inset 0 0 16px rgba(0,0,255,0.1), 0 0 30px rgba(0,0,255,0.1), $boxOffset * 1 0 20px darken($text-color, 45%), $boxOffset * 3 0 60px darken($text-color, 30%);

      &--on {
        box-shadow:  $boxOffset 0 0 black, 0 -1px 0 rgb(20, 20, 30), inset 0 0 16px rgba(0,0,255,0.1), 0 0 30px rgba(0,0,255,0.1), $boxOffset * 1 0 15px darken($text-color, 30%), $boxOffset * 1 0 20px darken($text-color, 45%), $boxOffset * 3 0 60px darken($text-color, 30%);
      }
    }
    &__column {
      flex-direction: column;
      width: 11.11111%;
      flex-grow: 0;
      flex-shrink: 0;

      &--mobile {
        width: 33.3333%;
      }

      &::before,
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 30%;
        width: 3px;
        height: 100%;
        background: #000;
        z-index: 0;
      }

      &::after {
        left: auto;
        right: 30%;
        z-index: 0;
      }

      &>* {
        z-index: 1;
      }

      &:nth-child(1) {
        transform: rotateY(60deg) scaleY(128%);
        .solp-matrix-display {
          @include displayshadow(-12px);
        }
      }
      &:nth-child(2) {
        transform: rotateY(45deg) scaleY(115%);
        .solp-matrix-display {
          @include displayshadow(-9px);
        }
      }
      &:nth-child(3) {
        transform: rotateY(30deg) scaleY(107%);
        .solp-matrix-display {
          @include displayshadow(-6px);
        }
      }
      &:nth-child(4) {
        transform: rotateY(15deg) scaleY(102%);
        .solp-matrix-display {
          @include displayshadow(-3px);
        }
      }
      &:nth-child(5) {
        transform: rotateY(0);
        .solp-matrix-display {
          @include displayshadow(0px);
        }
      }
      &:nth-child(6) {
        transform: rotateY(-15deg) scaleY(102%);
        .solp-matrix-display {
          @include displayshadow(3px);
        }
      }
      &:nth-child(7) {
        transform: rotateY(-30deg) scaleY(107%);
        .solp-matrix-display {
          @include displayshadow(6px);
        }
      }
      &:nth-child(8) {
        transform: rotateY(-45deg) scaleY(115%);
        .solp-matrix-display {
          @include displayshadow(9px);
        }
      }
      &:nth-child(9) {
        transform: rotateY(-60deg) scaleY(127%);
        .solp-matrix-display {
          @include displayshadow(12px);
        }
      }

      &--mobile {
        &:nth-child(1) {
          transform: rotateY(15deg) scaleY(105%);
          .solp-matrix-display {
            @include displayshadow(-4px);
          }
        }
        &:nth-child(2) {
          transform: rotateY(0deg) scaleY(100%);
          .solp-matrix-display {
            @include displayshadow(0px);
          }
        }
        &:nth-child(3) {
          transform: rotateY(-15deg) scaleY(105%);
          .solp-matrix-display {
            @include displayshadow(4px);
          }
        }

        .solp-matrix-display {
          width: 75%;
        }
      }
    }
  }

  @keyframes grid-effects {
    from {
      transform: scale(1) rotate(0) translate(0, 0) rotateY(0deg);
    }

    to {
      transform: scale(1.15) rotate(5deg) translate(-10%, -10%) rotateY(10deg);
    }
  }

  .solp-clouds {
    position: absolute;
    z-index: 100;
    background: url('./assets/clouds.png');
    background-size: cover;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    opacity: 0.25;
    animation-iteration-count: infinite;
    animation-name: clouds;
    animation-duration: 20s;
    animation-timing-function: linear;;
  }

  @keyframes clouds {
    from {
      transform: rotate(0) scale(300%);
    }

    to {
      transform: rotate(360deg) scale(300%);
    }
  }
</style>
